import React from 'react'
import i18n from '../i18n'

const LangSwitch = () => {

  const link = window.location.pathname
    .replace('/en/', '/')
    .replace('/cs/', '/')

  const handlerSelect = (e: any) => {
    if (e.target.value !== i18n.language) {
      window.location.assign(e.target.value !== 'cs' ? ('/en' + link) : link)
    }
  }

  return (
    <div className="noprint lang-switch">
      <select name="lang-switch-select" id="lang-switch-select" onChange={handlerSelect}>
        <option value="cs" selected={i18n.language === 'cs'} aria-label="Čeština">
          CS
        </option>
        <option value="en" selected={i18n.language === 'en'} aria-label="English">
          EN
        </option>
      </select>
      <label htmlFor="lang-switch" className="u-sr-only" style={{ color: '#fff' }}>
        Změna jazyka
      </label>
      <i className="fas fa-angle-down"></i>
    </div>
  )
}

export default LangSwitch
